/**
 * 随访模块路由配置
 */
 import VisitApprove from '../components/visit/approve';
 
 const routes = [
     {'path': '/visit/approve', 'component': VisitApprove} // 医生审核
 ];
 
 export default routes